import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Dropdown,
  Checkbox,
  Dimmer,
  Segment,
  Loader,
  Popup,
  List,
  Button,
} from 'semantic-ui-react';
import $ from 'jquery';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import cloneDeep from 'lodash/cloneDeep';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import api from '../../api';
import WithRouter from '../Extensions/WithRouter';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import assignBtn from '../../images/components/my/assign_button.svg';
import NestedAssignIssue from '../Extensions/NestedAssignIssue';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';
import CreateUserIssueModal from '../Jira/CreateUserIssueModal';

class OverviewIssueItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDetailLoading: props.isDetailLoading,
      isDetailPageLoading: props.isDetailPageLoading,
      isLoadingPopup: false,
      //isLoadingnestedPopup: false,
      isOpenNestedPopup: false,
      activeNestedPopup: '',
      uid: '',
      errorDetail: props.errorDetail,
      rowData: props.rowData,
      activeIndex: props.activeIndex,
      isVisible: props.isVisible,
      isScrolling: props.isScrolling,
      checkAllArray: props.checkAllArray,
      //checkAllSecurityArray: props.checkAllSecurityArray,
      //checkAllLicenseArray: props.checkAllLicenseArray,
      //checkAllLitigator: props.checkAllLitigator,
      checkedValue: props.checkedValue,
      unCheckedValue: props.unCheckedValue,
      popupStatus: {
        owner: false,
        file_security: false,
        file_license: false,
        file_litigator: false,
        component_security: false,
        component_license: false,
        component_litigator: false,
      },
      fileIssueList: [],
      ownerList: [],
      modifiedArray: [],
      activePopupIndex: '',
      //selectedValue: '',
      isOpenMCI: false,
    };
    this.onCheckUploadedFile = this.onCheckUploadedFile.bind(this);
    this.onCheckScannedFile = this.onCheckScannedFile.bind(this);
    this.changesIssueOwner = this.changesIssueOwner.bind(this);
    this.handleDetailScroll = this.handleDetailScroll.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.saveIssueWithFile = this.saveIssueWithFile.bind(this);
    this.saveIssueWithComponent = this.saveIssueWithComponent.bind(this);
    this.openNestedPopup = this.openNestedPopup.bind(this);
    this.handleMCIOpen = this.handleMCIOpen.bind(this);
    this.handleIssueCallback = this.handleIssueCallback.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeNestedPopup = this.closeNestedPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.wide_card_table .uploaded_file_wrap .info span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_table .uploaded_file_wrap .name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const {
      activeIndex,
      checkedValue,
      checkAllArray,
      unCheckedValue,
      rowData,
      isDetailLoading,
      isDetailPageLoading,
      errorDetail,
      isScrolling,
      isVisible
    } = this.props;

    if (prevProps.activeIndex.length !== activeIndex.length) {
      this.setState({
        activeIndex,
      }, () => {
        this.onUpdatePopup(activeIndex);
      });
    }
    if (prevProps.checkedValue.length !== checkedValue.length) {
      this.setState({
        checkedValue,
      });
    }

    if (prevProps.checkAllArray.length !== checkAllArray.length) {
      this.setState({
        checkAllArray,
      });
    }

    if (prevProps.unCheckedValue.length !== unCheckedValue.length) {
      this.setState({
        unCheckedValue,
      });
    }

    if (typeof rowData.issue_status === 'undefined' && prevProps.rowData.issue_status) {
      this.setState({
        rowData,
      });
    }

    if (rowData.issue_list && prevProps.rowData.issue_list) {
      if (rowData.issue_list.length !== prevProps.rowData.issue_list.length) {
        /** scrolling for pagination */
        this.setState({
          rowData,
        });
      }
    }

    if (isDetailLoading !== prevProps.isDetailLoading) {
      this.setState({
        isDetailLoading,
      });
    }

    if (isDetailPageLoading !== prevProps.isDetailPageLoading) {
      this.setState({
        isDetailPageLoading,
      });
    }

    if (errorDetail !== prevProps.errorDetail) {
      this.setState({
        errorDetail,
      });
    }

    if (isScrolling !== prevProps.isScrolling) {
      this.setState({
        isScrolling,
      });
    }

    if (isVisible !== prevProps.isVisible) {
      this.setState({
        isVisible,
      });
    }

    if (rowData.issue_owner) {
      if (rowData.issue_owner !== prevProps.rowData.issue_owner) {
        this.setState({
          rowData,
        });
      }
    }

    if (rowData.issue_status && prevProps.rowData.issue_list) {
      if (rowData.issue_status.undecided !== prevProps.rowData.issue_status.undecided
          || rowData.issue_status.resolved !== prevProps.rowData.issue_status.resolved
          || rowData.issue_status.disregarded !== prevProps.rowData.issue_status.disregarded
      ) {
        this.setState({
          rowData,
        });
      }
    }

  }

  handleMCIOpen(uid) {
    this.setState({
      isOpenMCI: true,
      uid,
    });
  }

  handleIssueCallback() {
    const { handleIssueCallback } = this.props;
    handleIssueCallback();
  }

  onUpdatePopup = (array) => {
    const { activePopupIndex } = this.state;
    const string = activePopupIndex.split('_');
    const uploadedFileId = Number(string[0]);

    if (array.indexOf(uploadedFileId) < 0) {
      this.setState({
        activePopupIndex: '',
      });
    }
  };

  onCheckUploadedFile = (e, { value }) => {
    const {
      checkedValue, unCheckedValue, activeIndex, rowData, checkAllArray
    } = this.state;
    const { updateCheckValue, updateCheckArray, updateUnCheckArray } = this.props;
    let newState;
    let newStateCheckAll;

    /** opened */
    if (activeIndex.indexOf(value) > -1) {
      const scannedFileIds = rowData.issue_list.map((item) => {
        return `${value}_${item.scanned_file_id}`;
      });

      if (checkedValue.indexOf(value) > -1) {
        newState = checkedValue.filter((item) => {
          return item !== value;
        });

        newState = newState.filter((item) => {
          return scannedFileIds.indexOf(item) === -1;
        });

        newStateCheckAll = checkAllArray.filter((item) => {
          return item !== value;
        });

        updateCheckValue(newState);
        updateCheckArray(newStateCheckAll, 'checkAllArray');
      } else {
        newState = [...checkedValue, value];
        newStateCheckAll = [...checkAllArray, value];
        newState = newState.concat(scannedFileIds);

        updateCheckValue(newState);
        updateCheckArray(newStateCheckAll, 'checkAllArray');
      }
    }

    /** closed */
    if (activeIndex.indexOf(value) === -1) {
      if (checkedValue.indexOf(value) > -1) {
        newState = checkedValue.filter((item) => {
          return item !== value;
        });

        newState = newState.filter((item) => {
          return String(item).indexOf(value) === -1;
        });
        newStateCheckAll = checkAllArray.filter((item) => {
          return item !== value;
        });

        updateCheckValue(newState);
        updateCheckArray(newStateCheckAll, 'checkAllArray');
      } else {
        newState = [...checkedValue, value];
        newStateCheckAll = [...checkAllArray, value];

        if (rowData.issue_list) {
          const scannedFileIds = rowData.issue_list.map((item) => {
            return `${value}_${item.scanned_file_id}`;
          });

          newState = newState.concat(scannedFileIds);
          const unique = newState.reduce((a, b) => {
            if (a.indexOf(b) < 0) {
              a.push(b);
            }
            return a;
          }, []);

          newState = unique;
        }

        updateCheckValue(newState);
        updateCheckArray(newStateCheckAll, 'checkAllArray');
      }
    }
    const newStateUnCheck = unCheckedValue.filter((item) => {
      const stringValues = item.split('_');
      return item !== Number(stringValues[0]);
    });
    updateUnCheckArray(newStateUnCheck);
  };

  onCheckScannedFile = (e, { value }) => {
    const {
      checkAllArray, checkedValue, unCheckedValue, rowData
    } = this.state;

    const { updateCheckValue, updateUnCheckArray } = this.props;

    const string = value.split('_');
    const uploadedFileId = Number(string[0]);

    let newState;
    let unCheckArray;

    const scannedFileIds = rowData.issue_list.map((item) => {
      return `${uploadedFileId}_${item.scanned_file_id}`;
    });

    if (checkedValue.indexOf(value) > -1) {
      newState = checkedValue.filter((item) => {
        return item !== value;
      });

      newState = newState.filter((item) => {
        return item !== uploadedFileId;
      });

      if (checkAllArray.indexOf(uploadedFileId) > -1) {
        unCheckArray = [...unCheckedValue, value];
        updateUnCheckArray(unCheckArray);
      }
      updateCheckValue(newState);
    } else {
      newState = [...checkedValue, value];
      const rowCheckedArray = scannedFileIds.filter((item) => {
        return newState.indexOf(item) > -1;
      });

      if (rowCheckedArray.length !== 0 && rowCheckedArray.length === rowData.issue_list.length) {
        newState = [...newState, uploadedFileId];
      }

      updateCheckValue(newState);
    }
  };
  /*
  onCheck = (e, { value }) => {
    const string = value.split('_');
    const uploadedFileId = Number(string[0]);
    const selectedColString = string[1];
    let text;
    let newState;
    let newSpreadNoti;

    const {
      checkedValue,
      //unCheckedValue,
      //checkAllSecurityArray,
      //checkAllLicenseArray,
      //checkAllLitigator,
      rowData,
      activeIndex,
    } = this.state;

    switch (true) {
    case selectedColString === 'security':
      text = 'checkAllSecurityArray';
      break;
    case selectedColString === 'license':
      text = 'checkAllLicenseArray';
      break;
    case selectedColString === 'litigator':
      text = 'checkAllLitigator';
      break;
    default:
      break;
    }

    // eslint-disable-next-line react/destructuring-assignment
    const spreadNoti = this.state[text];

    if (activeIndex.indexOf(uploadedFileId) > -1) { ///table이 열려있으면
      const componentFileIds = [];
      const scannedFileIds = rowData.issue_list.map((item) => {
        return `${uploadedFileId}_${item.scanned_file_id}_${selectedColString}`;
      });

      rowData.issue_list.map((item) => {
        return item.components.map((entity) => {
          return componentFileIds.push(`${uploadedFileId}_${entity.scanned_file_id}_${entity.file_component_id}_${selectedColString}`);
        });
      });

      if (checkedValue.indexOf(value) > -1) { /// check가 되어있으면
        newState = checkedValue.filter((item) => {
          return scannedFileIds.indexOf(item) === -1;
        });

        newState = newState.filter((item) => {
          return componentFileIds.indexOf(item) === -1;
        });

        newState = newState.filter((item) => {
          return item !== value;
        });

        newSpreadNoti = spreadNoti.filter((item) => {
          return item !== uploadedFileId;
        });

        if (text) {
          this.setState({
            [text]: newSpreadNoti,
            checkedValue: newState,
          });
        }
      } else {
        newState = [...checkedValue, value];
        newState = newState.concat(scannedFileIds);
        newState = newState.concat(componentFileIds);

        const unique = newState.reduce((a, b) => {
          if (a.indexOf(b) < 0) {
            a.push(b);
          }
          return a;
        }, []);

        if (text) {
          this.setState({
            [text]: [...spreadNoti, uploadedFileId],
            checkedValue: unique,
          });
        }
      }
    }

    if (activeIndex.indexOf(uploadedFileId) === -1) {
      if (checkedValue.indexOf(value) > -1) {
        newState = checkedValue.filter((item) => {
          return item !== value;
        });

        newSpreadNoti = spreadNoti.filter((item) => {
          return item !== uploadedFileId;
        });

        if (text) {
          this.setState({
            [text]: newSpreadNoti,
            checkedValue: newState,
          });
        }
      } else {
        newState = [...checkedValue, value];
        if (text) {
          this.setState({
            [text]: [...spreadNoti, uploadedFileId],
            checkedValue: newState,
          });
        }
      }
    }
  };

  onCheckFileAll = (e, { value }) => {
    const { checkedValue, rowData } = this.state;
    let newState = [];
    const string = value.split('_');
    const scannedFileId = Number(string[1]);

    const fileArray = checkedValue.filter((item) => {
      return item === value;
    });
    const findIndex = rowData.issue_list.findIndex((item) => {
      return item.scanned_file_id === scannedFileId;
    });

    const componentIds = rowData.issue_list[findIndex].components.map((item) => {
      return item.file_component_id;
    });

    if (fileArray.length === 0) {
      newState = [...checkedValue];
      const ids = componentIds.map((item) => {
        return `${value}_${item}`;
      });
      ids.push(value);

      ids.map((item) => {
        newState = newState.concat(item, `${item}_security`, `${item}_license`, `${item}_litigator`);
        return newState;
      });

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        checkedValue: unique,
      });
    } else {
      newState = checkedValue.filter((item) => {
        return item.indexOf((value)) < 0;
      });
      this.setState({
        checkedValue: newState,
      });
    }

  };

  onCheckFile = (e, { value }) => {
    const { checkedValue, rowData } = this.state;
    let newState;
    const string = value.split('_');
    const mainString = `${string[0]}_${string[1]}`;
    //const uploadedFileId = string[0];
    const scannedFileId = Number(string[1]);
    const fileIndex = rowData.issue_list.findIndex((item) => {
      return item.scanned_file_id === scannedFileId;
    });

    const componentColArray = rowData.issue_list[fileIndex].components.map((entity) => {
      return `${mainString}_${entity.file_component_id}_${string[2]}`;
    });

    const componentIdArray = rowData.issue_list[fileIndex].components.map((entity) => {
      return `${mainString}_${entity.file_component_id}`;
    });

    if (checkedValue.indexOf(value) > -1) {
      const checkedArray = checkedValue.filter((el) => {
        return el !== value && el !== mainString;
      });

      newState = checkedArray.filter((item) => {
        return componentColArray.indexOf(item) === -1;
      });

      newState = newState.filter((item) => {
        return componentIdArray.indexOf(item) === -1;
      });
    } else {
      let checkedArray = [...checkedValue, value];
      checkedArray = checkedArray.concat(componentColArray);
      const checkAllArray = checkedArray.filter((item) => {
        return item === `${mainString}_security` || item === `${mainString}_license` || item === `${mainString}_litigator`;
      });

      if (checkAllArray.length === 3) {
        newState = [...checkedArray, mainString];
        newState = newState.concat(componentIdArray);
      } else {
        newState = checkedArray;
      }
    }

    this.setState({
      checkedValue: newState,
    });
  };

  onCheckComponentAll = (e, { value }) => {
    const { checkedValue } = this.state;
    let newState;

    const componentArray = checkedValue.filter((item) => {
      return item === value;
    });

    if (componentArray.length === 0) {
      newState = [...checkedValue, value, `${value}_security`, `${value}_license`, `${value}_litigator`];
      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        checkedValue: unique,
      });
    } else {
      newState = checkedValue.filter((item) => {
        return item.indexOf((value)) < 0;
      });
      this.setState({
        checkedValue: newState,
      });
    }
  };

  onCheckComponent = (e, { value }) => {
    const { checkedValue } = this.state;
    const string = value.split('_');
    const mainString = `${string[0]}_${string[1]}_${string[2]}`;

    let newState;
    if (checkedValue.indexOf(value) > -1) {
      const checkedArray = checkedValue.filter((el) => {
        return el !== value;
      });

      newState = checkedArray.filter((item) => {
        return item !== mainString;
      });

      newState = newState.filter((item) => {
        return item !== `${string[0]}_${string[1]}_${string[3]}`;
      });
    } else {
      const checkedArray = [...checkedValue, value];
      const checkAllArray = checkedArray.filter((item) => {
        return item.indexOf(mainString) > -1;
      });

      if (checkAllArray.length === 3) {
        newState = [...checkedArray, mainString];
      } else {
        newState = checkedArray;
      }
    }

    this.setState({
      checkedValue: newState,
    });

  };
  */

  getIssueOwner = (ufid) => {
    const status = {
      owner: true,
    };

    api
      .getIssueOwner(ufid)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activePopupIndex: ufid,
          ownerList: data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getFileIssue = (value) => {
    let status;
    let ids;
    const string = value.split('_');
    const uploadedFileId = Number(string[0]);
    const scannedFileId = Number(string[1]);
    const type = string[2];

    if (type === 'security') {
      status = {
        owner: false,
        file_security: true,
        file_license: false,
        file_litigator: false,
        component_security: false,
        component_license: false,
        component_litigator: false,
      };

      ids = {
        uploadedFileId,
        scannedFileId,
      };

      this.setState({
        isLoadingPopup: true,
        popupStatus: status,
        activePopupIndex: value,
      }, () => {
        api
          .getSecurityFileIssues(ids)
          .then((response) => {
            const data = response.response;
            this.setState({
              fileIssueList: data,
              modifiedArray: [],
              isLoadingPopup: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'license') {
      status = {
        owner: false,
        file_security: false,
        file_license: true,
        file_litigator: false,
        component_security: false,
        component_license: false,
        component_litigator: false,
      };

      ids = {
        uploadedFileId,
        scannedFileId,
      };

      this.setState({
        isLoadingPopup: true,
        popupStatus: status,
        activePopupIndex: value,
      }, () => {
        api
          .getLicenseFileIssues(ids)
          .then((response) => {
            const data = response.response;
            this.setState({
              fileIssueList: data,
              modifiedArray: [],
              isLoadingPopup: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'litigator') {
      status = {
        owner: false,
        file_security: false,
        file_license: false,
        file_litigator: true,
        component_security: false,
        component_license: false,
        component_litigator: false,
      };

      ids = {
        uploadedFileId,
        scannedFileId,
      };

      this.setState({
        isLoadingPopup: true,
        popupStatus: status,
        activePopupIndex: value,
      }, () => {
        api
          .getLitigatorFileIssues(ids)
          .then((response) => {
            const data = response.response;
            this.setState({
              fileIssueList: data,
              modifiedArray: [],
              isLoadingPopup: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }
  };

  getComponentIssue = (value) => {
    let status;
    let ids;
    const string = value.split('_');
    const uploadedFileId = Number(string[0]);
    const scannedFileId = Number(string[1]);
    const componentId = Number(string[2]);
    const type = string[3];

    if (type === 'security') {
      status = {
        owner: false,
        file_security: false,
        file_license: false,
        file_litigator: false,
        component_security: true,
        component_license: false,
        component_litigator: false,
      };

      ids = {
        uploadedFileId,
        scannedFileId,
        componentId,
      };

      this.setState({
        isLoadingPopup: true,
        popupStatus: status,
        activePopupIndex: value,
      }, () => {
        api
          .getSecurityComponentIssues(ids)
          .then((response) => {
            const data = response.response;
            this.setState({
              fileIssueList: data,
              modifiedArray: [],
              isLoadingPopup: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'license') {
      status = {
        owner: false,
        file_security: false,
        file_license: false,
        file_litigator: false,
        component_security: false,
        component_license: true,
        component_litigator: false,
      };

      ids = {
        uploadedFileId,
        scannedFileId,
        componentId,
      };

      this.setState({
        isLoadingPopup: true,
        popupStatus: status,
        activePopupIndex: value,
      }, () => {
        api
          .getLicenseComponentIssues(ids)
          .then((response) => {
            const data = response.response;
            this.setState({
              fileIssueList: data,
              modifiedArray: [],
              isLoadingPopup: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'litigator') {
      status = {
        owner: false,
        file_security: false,
        file_license: false,
        file_litigator: false,
        component_security: false,
        component_license: false,
        component_litigator: true,
      };

      ids = {
        uploadedFileId,
        scannedFileId,
        componentId,
      };

      this.setState({
        isLoadingPopup: true,
        popupStatus: status,
        activePopupIndex: value,
      }, () => {
        api
          .getLitigatorComponentIssues(ids)
          .then((response) => {
            const data = response.response;
            this.setState({
              fileIssueList: data,
              modifiedArray: [],
              isLoadingPopup: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }
  };

  toggleRow = (e, uid) => {
    const { toggleRow } = this.props;
    if (e.target.tagName === 'LABEL') {
      return;
    }
    if (e.target.classList.contains('jira') || e.target.classList.contains('jira_issue')) {
      return;
    }

    toggleRow(e, uid);
  };

  handleStatusChange = (value, id) => {
    const { fileIssueList, modifiedArray } = this.state;
    const findIndex = fileIssueList.findIndex((item) => {
      return item.id === id;
    });

    if (value === fileIssueList[findIndex].status) {
      return;
    }

    const clonedArray = [...modifiedArray];
    let selectedValue;
    let newArray;

    const existArray = clonedArray.filter((item) => {
      return item.id === id;
    });

    if (existArray.length === 0) {
      selectedValue = {
        id: fileIssueList[findIndex].id,
        status: value,
        owner_id: fileIssueList[findIndex].owner_id || null,
      };
      newArray = [...clonedArray, selectedValue];
    } else {
      const selectedIndex = clonedArray.findIndex((item) => {
        return item.id === id;
      });
      const updatedData = Update(clonedArray[selectedIndex], {
        status: {
          $set: value,
        },
      });

      newArray = Update(clonedArray, {
        $splice: [[selectedIndex, 1, updatedData]],
      });
    }

    //{"id": 16123478, "status": "resolved", "owner_id": 27}

    this.setState({
      fileIssueList: Update(fileIssueList, {
        [findIndex]: {
          status: {
            $set: value,
          },
        },
      }),
      modifiedArray: newArray,
    });
  };

  handleDetailScroll = (event) => {
    const { rowData, errorDetail, isDetailPageLoading } = this.state;
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const { handleDetailScroll } = this.props;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (errorDetail || isDetailPageLoading || rowData.detail_info.next === null) {
      return;
    }

    if (scrolledToBottom) {
      handleDetailScroll(rowData.uploaded_file_id, rowData.detail_info.current + 1, rowData.detail_info.per_page);
    }
  };

  changesIssueOwner = (obj) => {
    const { fileIssueList, modifiedArray } = this.state;
    const ownerId = obj.selectedId;
    const ownerName = obj.owner;
    const issueIds = obj.id;
    const string = issueIds.split('_');

    let selectedValue;
    let newArray;
    let issueId;

    if (string.length === 5) {
      issueId = Number(string[4]);
    } else {
      issueId = Number(string[3]);
    }
    const updatedIndex = fileIssueList.findIndex((item) => {
      return item.id === issueId;
    });

    if (fileIssueList[updatedIndex].owner_id && fileIssueList[updatedIndex].owner_id === ownerId) {
      return this.setState({
        isOpenNestedPopup: false,
        activeNestedPopup: '',
      });
    }

    const existModifiedIndex = modifiedArray.findIndex((item) => {
      return item.id === issueId;
    });

    if (existModifiedIndex < 0) {
      selectedValue = {
        id: issueId,
        status: fileIssueList[updatedIndex].status,
        owner_id: ownerId,
      };
      newArray = [...modifiedArray, selectedValue];
    } else {
      const updatedData = Update(modifiedArray[existModifiedIndex], {
        owner_id: {
          $set: ownerId,
        },
      });
      newArray = Update(modifiedArray, {
        $splice: [[existModifiedIndex, 1, updatedData]],
      });
    }

    this.setState({
      fileIssueList: Update(fileIssueList, {
        [updatedIndex]: {
          owner_id: {
            $set: ownerId,
          },
          owner: {
            $set: ownerName,
          },
        },
      }),
      modifiedArray: newArray,
      isOpenNestedPopup: false,
      activeNestedPopup: '',
    });
  };

  openNestedPopup = (value, id) => {
    const string = value.split('_');
    const uploadedFileId = Number(string[0]);

    this.setState({
      isOpenNestedPopup: true,
      activeNestedPopup: `${value}_${id}`,
      uploadedFileId,
    });
  };

  saveIssueWithComponent(value) {
    const { modifiedArray, rowData } = this.state;
    const { updatePopupCallback } = this.props;
    const string = value.split('_');
    const uploadedFileId = Number(string[0]);
    const scannedFileId = Number(string[1]);
    const componentId = Number(string[2]);
    const type = string[3];
    let data;
    let ids;

    if (type === 'security') {
      ids = {
        uploadedFileId,
        scannedFileId,
        componentId,
      };
      data = {
        checked: modifiedArray,
      };
      this.setState({
        isLoadingPopup: true,
      }, () => {
        api
          .setSecurityComponentIssues(data, ids)
          .then(() => {
            this.setState({
              //fileIsseLuist: [],
              isLoadingPopup: false,
              modifiedArray: [],
            });
            this.closePopup();
            updatePopupCallback(rowData.uploaded_file_id);
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'license') {
      ids = {
        uploadedFileId,
        scannedFileId,
        componentId,
      };
      data = {
        checked: modifiedArray,
      };
      this.setState({
        isLoadingPopup: true,
      }, () => {
        api
          .setLicenseComponentIssues(data, ids)
          .then(() => {
            this.setState({
              //fileIsseLuist: [],
              isLoadingPopup: false,
              modifiedArray: [],
            });
            this.closePopup();
            updatePopupCallback(rowData.uploaded_file_id);
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'litigator') {
      ids = {
        uploadedFileId,
        scannedFileId,
        componentId,
      };
      data = {
        checked: modifiedArray,
      };
      this.setState({
        isLoadingPopup: true,
      }, () => {
        api
          .setLitigatorComponentIssues(data, ids)
          .then(() => {
            this.setState({
              //fileIsseLuist: [],
              isLoadingPopup: false,
              modifiedArray: [],
            });
            this.closePopup();
            updatePopupCallback(rowData.uploaded_file_id);
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }
  }

  saveIssueWithFile(value) {
    const { modifiedArray, rowData } = this.state;
    const { updatePopupCallback } = this.props;
    const string = value.split('_');
    const uploadedFileId = Number(string[0]);
    const scannedFileId = Number(string[1]);
    const type = string[2];
    let data;
    let ids;

    if (type === 'security') {
      ids = {
        uploadedFileId,
        scannedFileId,
      };
      data = {
        checked: modifiedArray,
      };
      this.setState({
        isLoadingPopup: true,
      }, () => {
        api
          .setSecurityFileIssues(data, ids)
          .then(() => {
            this.setState({
              //fileIsseLuist: [],
              isLoadingPopup: false,
              modifiedArray: [],
            });
            this.closePopup();
            updatePopupCallback(rowData.uploaded_file_id);
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'license') {
      ids = {
        uploadedFileId,
        scannedFileId,
      };
      data = {
        checked: modifiedArray,
      };
      this.setState({
        isLoadingPopup: true,
      }, () => {
        api
          .setLicenseFileIssues(data, ids)
          .then(() => {
            this.setState({
              //fileIsseLuist: [],
              isLoadingPopup: false,
              modifiedArray: [],
            });
            this.closePopup();
            updatePopupCallback(rowData.uploaded_file_id);
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }

    if (type === 'litigator') {
      ids = {
        uploadedFileId,
        scannedFileId,
      };
      data = {
        checked: modifiedArray,
      };
      this.setState({
        isLoadingPopup: true,
      }, () => {
        api
          .setLitigatorFileIssues(data, ids)
          .then(() => {
            this.setState({
              //fileIsseLuist: [],
              isLoadingPopup: false,
              modifiedArray: [],
            });
            this.closePopup();
            updatePopupCallback(rowData.uploaded_file_id);
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingPopup: false,
            });
          });
      });
    }
  }

  closeNestedPopup() {
    this.setState({
      isOpenNestedPopup: false,
      activeNestedPopup: '',
    });
  }

  closePopup() {
    const status = {
      owner: false,
      file_security: false,
      file_license: false,
      file_litigator: false,
      component_security: false,
      component_license: false,
      component_litigator: false,
    };

    this.setState({
      popupStatus: status,
      activePopupIndex: '',
      ownerList: [],
      fileIssueList: [],
      modifiedArray: [],
      isOpenNestedPopup: false,
      activeNestedPopup: '',
    });
  }

  closeModal() {
    this.setState({
      isOpenMCI: false,
    });
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      if (shortValue % 1 !== 0) {
        shortValue = shortValue.toFixed(1);
      }
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  converToString(string) {
    const toUpper = string.slice(0, 1).toUpperCase();
    const toLower = string.slice(1).toLowerCase();
    return toUpper.concat(toLower);
  }

  renderBarChart = (status) => {
    const { translate } = this.props;
    const currentLocale = localStorage.getItem('i18nextLng');
    const dummyData = cloneDeep(status);
    delete dummyData.total;

    if (status.undecided === 0 && status.resolved === 0 && status.disregarded === 0) {
      return (
        <div className="vertical_bar_chart">
          <div className="blue">
            <div className="bar" style={{ height: '0' }} />
            <div className="value" style={{ bottom: '0' }}>{status.undecided}</div>
            <div
              className={cx(
                'label',
                {
                  kr: currentLocale === 'kr',
                },
                {
                  ja: currentLocale === 'ja',
                },
                {
                  en: currentLocale === 'en',
                },
              )}
            >
              {translate('panel.menu.undecided')}
            </div>
          </div>
          <div className="green">
            <div className="bar" style={{ height: '0' }} />
            <div className="value" style={{ bottom: '0' }}>{status.resolved}</div>
            <div className="label">{translate('panel.menu.resolved')}</div>
          </div>
          <div className="gray">
            <div className="bar" style={{ height: '0' }} />
            <div className="value" style={{ bottom: '0' }}>{status.disregarded}</div>
            <div
              className={cx(
                'label',
                {
                  kr: currentLocale === 'kr',
                },
                {
                  ja: currentLocale === 'ja',
                },
                {
                  en: currentLocale === 'en',
                },
              )}
            >
              {translate('panel.menu.disregarded')}
            </div>
          </div>
        </div>
      );
    }

    const maxKey = Object.keys(dummyData).reduce((a, b) => {
      return dummyData[a] > dummyData[b] ? a : b;
    });

    const undecidedValue = `${Math.round((status.undecided / status[maxKey]) * 100)}%`;
    const resolveddValue = `${Math.round((status.resolved / status[maxKey]) * 100)}%`;
    const disregardedValue = `${Math.round((status.disregarded / status[maxKey]) * 100)}%`;

    return (
      <div className="vertical_bar_chart">
        <div className="blue">
          <div className="bar" style={{ height: undecidedValue || 0 }} />
          <div className="value" style={{ bottom: undecidedValue || 0 }}>{this.abbreviateNumber(status.undecided)}</div>
          <div
            className={cx(
              'label',
              {
                kr: currentLocale === 'kr',
              },
              {
                ja: currentLocale === 'ja',
              },
              {
                en: currentLocale === 'en',
              },
            )}
          >
            {translate('panel.menu.undecided')}
          </div>
        </div>
        <div className="green">
          <div className="bar" style={{ height: resolveddValue || 0 }} />
          <div className="value" style={{ bottom: resolveddValue || 0 }}>{this.abbreviateNumber(status.resolved)}</div>
          <div
            className={cx(
              'label',
              {
                kr: currentLocale === 'kr',
              },
              {
                ja: currentLocale === 'ja',
              },
              {
                en: currentLocale === 'en',
              },
            )}
          >
            {translate('panel.menu.resolved')}
          </div>
        </div>
        <div className="gray">
          <div className="bar" style={{ height: disregardedValue || 0 }} />
          <div className="value" style={{ bottom: disregardedValue || 0 }}>{this.abbreviateNumber(status.disregarded)}</div>
          <div
            className={cx(
              'label',
              {
                kr: currentLocale === 'kr',
              },
              {
                ja: currentLocale === 'ja',
              },
              {
                en: currentLocale === 'en',
              },
            )}
          >
            {translate('panel.menu.disregarded')}
          </div>
        </div>
      </div>
    );
  };

  renderRowWithLitigator = (array, id) => {
    const { isOpenNestedPopup, activeNestedPopup, uploadedFileId } = this.state;
    const { translate } = this.props;
    if (typeof array === 'undefined' || array.length === 0 || typeof array[0].code === 'undefined') {
      return;
    }
    const mcArray = array.filter((item) => {
      return item.code.toLowerCase().indexOf('mchardy') > -1;
    });
    const sfcArray = array.filter((item) => {
      return item.code.toLowerCase().indexOf('sfc') > -1;
    });
    const paArray = array.filter((item) => {
      return item.code.toLowerCase().indexOf('patent') > -1;
    });

    const newObject = {
      mchardy: mcArray,
      sfc: sfcArray,
      patent: paArray,
    };

    const options = [
      {
        key: '0',
        text: translate('panel.menu.undecided'),
        value: 'undecided',
        content: 'Undecided',
      },
      {
        key: '1',
        text: translate('panel.menu.resolved'),
        value: 'resolved',
        content: 'Resolved',
      },
      {
        key: '2',
        text: translate('panel.menu.disregarded'),
        value: 'disregarded',
        content: 'Disregarded',
      },
    ];

    return Object.keys(newObject).map((key) => {
      return newObject[key].map((item, i) => {
        return (
          <tr key={uuidv4()}>
            {
              i === 0 ? (
                <td rowSpan={newObject[key].length} className="scope">
                  <div className="block">
                    {item.code}
                  </div>
                </td>
              ) : null
            }
            <td>
              <div className="block">
                {item.component_name}
              </div>
            </td>
            <td>
              <Dropdown
                className={cx(
                  'round_button bullet_round',
                  {
                    bullet_blue: item.status === 'undecided',
                  },
                  {
                    bullet_green: item.status === 'resolved',
                  },
                  {
                    bullet_gray: item.status === 'disregarded',
                  },
                )}
                labeled
                text={this.converToString(item.status)}
              >
                <Dropdown.Menu>
                  {
                    options.map((option) => {
                      return (
                        <Dropdown.Item
                          className={cx(
                            'list_button bullet_round',
                            {
                              bullet_blue: option.value === 'undecided',
                            },
                            {
                              bullet_green: option.value === 'resolved',
                            },
                            {
                              bullet_gray: option.value === 'disregarded',
                            },
                          )}
                          key={uuidv4()}
                          value={option.value}
                          text={option.text}
                          onClick={() => {
                            return this.handleStatusChange(option.value, item.id);
                          }}
                          selected={option.value === item.status}
                        />
                      );
                    })
                  }
                </Dropdown.Menu>
              </Dropdown>
            </td>
            <td>
              <div className="block">
                {item.owner}
              </div>
            </td>
            <td>
              <div className="btn_block">
                <a
                  className=""
                  style={{ cursor: 'pointer' }}
                  onClick={() => { return this.openNestedPopup(id, item.id); }}
                  onKeyUp={() => { return this.openNestedPopup(id, item.id); }}
                >
                  <img src={assignBtn} alt="" />
                </a>
                {
                  isOpenNestedPopup && activeNestedPopup === `${id}_${item.id}` ? (
                    <NestedAssignIssue
                      id={`${id}_${item.id}`}
                      targetName={item.code}
                      closeNestedPopup={this.closeNestedPopup}
                      uploadedFileId={uploadedFileId}
                      isOpenNestedPopup={isOpenNestedPopup}
                      activeNestedPopup={activeNestedPopup}
                      changesIssueOwner={this.changesIssueOwner}
                      translate={translate}
                    />
                  ) : null
                }
              </div>
            </td>
          </tr>
        );
      });
    });

  };

  renderRowWithLicense = (array, id) => {
    const { isOpenNestedPopup, activeNestedPopup, uploadedFileId } = this.state;
    const { translate } = this.props;
    if (typeof array === 'undefined' || array.length === 0 || typeof array[0].family === 'undefined') {
      return;
    }
    const proArray = array.filter((item) => {
      return item.family === 'protective';
    });
    const perArray = array.filter((item) => {
      return item.family === 'permissive';
    });
    const othArray = array.filter((item) => {
      return item.family === 'others';
    });

    const newObject = {
      protective: proArray,
      permissive: perArray,
      others: othArray,
    };

    const options = [
      {
        key: '0',
        text: translate('panel.menu.undecided'),
        value: 'undecided',
        content: 'Undecided',
      },
      {
        key: '1',
        text: translate('panel.menu.resolved'),
        value: 'resolved',
        content: 'Resolved',
      },
      {
        key: '2',
        text: translate('panel.menu.disregarded'),
        value: 'disregarded',
        content: 'Disregarded',
      },
    ];

    return Object.keys(newObject).map((key) => {
      return newObject[key].map((item, i) => {
        return (
          <tr key={uuidv4()}>
            {
              i === 0 ? (
                <td rowSpan={newObject[key].length} className="scope">
                  <div className="block">
                    {this.converToString(item.family)}
                  </div>
                </td>
              ) : null
            }
            <td>
              <div className="checkbox" />
              <div
                className={cx(
                  'block bullet round',
                  {
                    bullet_red: item.family === 'protective',
                  },
                  {
                    bullet_orange: item.family === 'permissive',
                  },
                  {
                    bullet_yellow: item.family === 'others',
                  }
                )}
              >
                {item.name}
              </div>
            </td>
            <td>
              <div className="block">
                {item.component_name}
              </div>
            </td>
            <td>
              <Dropdown
                className={cx(
                  'round_button bullet_round',
                  {
                    bullet_blue: item.status === 'undecided',
                  },
                  {
                    bullet_green: item.status === 'resolved',
                  },
                  {
                    bullet_gray: item.status === 'disregarded',
                  },
                )}
                labeled
                text={this.converToString(item.status)}
              >
                <Dropdown.Menu>
                  {
                    options.map((option) => {
                      return (
                        <Dropdown.Item
                          className={cx(
                            'list_button bullet_round',
                            {
                              bullet_blue: option.value === 'undecided',
                            },
                            {
                              bullet_green: option.value === 'resolved',
                            },
                            {
                              bullet_gray: option.value === 'disregarded',
                            },
                          )}
                          key={uuidv4()}
                          value={option.value}
                          text={option.text}
                          onClick={() => {
                            return this.handleStatusChange(option.value, item.id);
                          }}
                          selected={option.value === item.status}
                        />
                      );
                    })
                  }
                </Dropdown.Menu>
              </Dropdown>
            </td>
            <td>
              <div className="block">
                {item.owner}
              </div>
            </td>
            <td>
              <div className="btn_block">
                <a
                  className=""
                  style={{ cursor: 'pointer' }}
                  onClick={() => { return this.openNestedPopup(id, item.id); }}
                  onKeyUp={() => { return this.openNestedPopup(id, item.id); }}
                >
                  <img src={assignBtn} alt="" />
                </a>
                {
                  isOpenNestedPopup && activeNestedPopup === `${id}_${item.id}` ? (
                    <NestedAssignIssue
                      id={`${id}_${item.id}`}
                      targetName={item.name}
                      closeNestedPopup={this.closeNestedPopup}
                      uploadedFileId={uploadedFileId}
                      isOpenNestedPopup={isOpenNestedPopup}
                      activeNestedPopup={activeNestedPopup}
                      changesIssueOwner={this.changesIssueOwner}
                      translate={translate}
                    />
                  ) : null
                }
              </div>
            </td>
          </tr>
        );
      });
    });
  };

  renderRowWithSecurity = (array, id) => {
    const { isOpenNestedPopup, activeNestedPopup, uploadedFileId } = this.state;
    const { translate } = this.props;
    if (typeof array === 'undefined' || array.length === 0 || typeof array[0].risk === 'undefined') {
      return;
    }

    const criticalArray = array.filter((item) => {
      return item.risk === 'critical';
    });
    const highArray = array.filter((item) => {
      return item.risk === 'high';
    });
    const mediumArray = array.filter((item) => {
      return item.risk === 'medium';
    });
    const lowArray = array.filter((item) => {
      return item.risk === 'low';
    });

    const newObject = {
      critical: criticalArray,
      high: highArray,
      medium: mediumArray,
      low: lowArray,
    };

    const options = [
      {
        key: '0',
        text: translate('panel.menu.undecided'),
        value: 'undecided',
        content: 'Undecided',
      },
      {
        key: '1',
        text: translate('panel.menu.resolved'),
        value: 'resolved',
        content: 'Resolved',
      },
      {
        key: '2',
        text: translate('panel.menu.disregarded'),
        value: 'disregarded',
        content: 'Disregarded',
      },
    ];

    return Object.keys(newObject).map((key) => {
      return newObject[key].map((item, i) => {
        return (
          <tr key={uuidv4()}>
            {
              i === 0 ? (
                <td rowSpan={newObject[key].length} className="scope">
                  <div className="block">
                    {this.converToString(item.risk)}
                  </div>
                </td>
              ) : null
            }
            <td>
              <div className="checkbox" />
              <div
                className={cx(
                  'block bullet',
                  {
                    bullet_red: item.risk === 'critical',
                  },
                  {
                    bullet_orange: item.risk === 'high',
                  },
                  {
                    bullet_cheese: item.risk === 'medium',
                  },
                  {
                    bullet_yellow: item.risk === 'low',
                  }
                )}
              >
                {item.code}
              </div>
            </td>
            <td>
              <div className="block">
                {item.component_name}
              </div>
            </td>
            <td>
              <Dropdown
                className={cx(
                  'round_button bullet_round',
                  {
                    bullet_blue: item.status === 'undecided',
                  },
                  {
                    bullet_green: item.status === 'resolved',
                  },
                  {
                    bullet_gray: item.status === 'disregarded',
                  },
                )}
                labeled
                text={this.converToString(item.status)}
              >
                <Dropdown.Menu>
                  {
                    options.map((option) => {
                      return (
                        <Dropdown.Item
                          className={cx(
                            'list_button bullet_round',
                            {
                              bullet_blue: option.value === 'undecided',
                            },
                            {
                              bullet_green: option.value === 'resolved',
                            },
                            {
                              bullet_gray: option.value === 'disregarded',
                            },
                          )}
                          key={uuidv4()}
                          value={option.value}
                          text={option.text}
                          onClick={() => {
                            return this.handleStatusChange(option.value, item.id);
                          }}
                          selected={option.value === item.status}
                        />
                      );
                    })
                  }
                </Dropdown.Menu>
              </Dropdown>
            </td>
            <td>
              <div className="block">
                {item.owner}
              </div>
            </td>
            <td>
              <div className="btn_block">
                <a
                  className=""
                  style={{ cursor: 'pointer' }}
                  onClick={() => { return this.openNestedPopup(id, item.id); }}
                  onKeyUp={() => { return this.openNestedPopup(id, item.id); }}
                >
                  <img src={assignBtn} alt="" />
                </a>
                {
                  isOpenNestedPopup && activeNestedPopup === `${id}_${item.id}` ? (
                    <NestedAssignIssue
                      id={`${id}_${item.id}`}
                      targetName={item.code}
                      closeNestedPopup={this.closeNestedPopup}
                      uploadedFileId={uploadedFileId}
                      isOpenNestedPopup={isOpenNestedPopup}
                      activeNestedPopup={activeNestedPopup}
                      changesIssueOwner={this.changesIssueOwner}
                      translate={translate}
                    />
                  ) : null
                }
              </div>
            </td>
          </tr>
        );
      });
    });
  };

  renderJiraIssueEle(obj) {
    const { translate } = this.props;
    const data = obj.jira_issue;

    if (data.url === '') {
      return (
        <Button
          className="jira"
          onClick={() => {
            return this.handleMCIOpen(
              obj.uploaded_file_id,
            );
          }}
        >
          <span className="icon-wrap">
            <img className="icon-jira" src={JiraLogo} alt="" />
          </span>
          {translate('settings.list.create_issue')}
        </Button>
      );
    }
    return (
      <span className="jira_issue">
        <a
          href={data.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline' }}
          className="jira_issue"
        >
          {data.key}
        </a>
      </span>
    );
  }

  render() {
    const {
      rowData,
      activeIndex,
      isDetailLoading,
      isDetailPageLoading,
      errorDetail,
      isVisible,
      isScrolling,
      checkedValue,
      activePopupIndex,
      popupStatus,
      fileIssueList,
      isLoadingPopup,
      ownerList,
      isOpenMCI,
      uid,
    } = this.state;
    const { translate, location } = this.props;

    const renderCheckValue = (value) => {
      const isCheckArray = checkedValue.filter((item) => {
        return item === value;
      });
      if (isCheckArray.length !== 0) {
        return true;
      }
      return false;
    };

    const renderIndeterminate = (value) => {
      if (!rowData.issue_list) {
        return false;
      }
      const scannedFileIds = rowData.issue_list.map((item) => {
        return `${value}_${item.scanned_file_id}`;
      });
      const isHasChild = scannedFileIds.filter((item) => {
        return checkedValue.indexOf(item) > -1;
      });

      if (isHasChild.length !== 0 && isHasChild.length < rowData.issue_list.length) {
        return true;
      }
      return false;
    };

    return (
      <div
        className={cx(
          'my_issues_item_box',
          {
            expand: activeIndex.indexOf(rowData.uploaded_file_id) >= 0,
          },
        )}
      >
        <table className="wide_card_table wide_card_scope">
          <colgroup>
            <col style={{ width: '3.9%', maxWidth: '36px' }} />
            <col style={{ width: '16.2%', maxWidth: '180px' }} />
            <col style={{ width: '5.5%', maxWidth: '62px' }} />
            <col style={{ width: '5.5%', maxWidth: '62px' }} />
            <col style={{ width: '5.5%', maxWidth: '62px' }} />
            <col style={{ width: '16%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '8.5%' }} />
            <col style={{ width: '' }} />
            <col style={{ width: '' }} />
            <col style={{ width: '4%', maxWidth: '40px' }} />
          </colgroup>
          <tbody>
            <tr
              className="first_line"
              onClick={(e) => {
                return this.toggleRow(e, rowData.uploaded_file_id);
              }}
            >
              <td className="checkbox_wrap">
                <Checkbox
                  value={rowData.uploaded_file_id}
                  checked={renderCheckValue(rowData.uploaded_file_id)}
                  indeterminate={renderIndeterminate(rowData.uploaded_file_id)}
                  onChange={this.onCheckUploadedFile}
                />
              </td>
              <td className="uploaded_file">
                <div className="uploaded_file_wrap">
                  <div className="name">
                    {rowData.name}
                  </div>
                  <div className="info">
                    <span>{rowData.project_name}</span>
                    <span>/</span>
                    <span>{rowData.project_version_name}</span>
                  </div>
                </div>
              </td>
              <td className="scanned_file">
                <p className="value_box">{rowData.scanned_file_count}</p>
              </td>
              <td className="component">
                <p className="value_box">{rowData.component_count.component}</p>
              </td>
              <td className="comp_version">
                {rowData.component_count.version}
              </td>
              <td className="security_risk">
                {/**
                <Checkbox
                  value={`${rowData.uploaded_file_id}_security`}
                  checked={renderCheckValue(`${rowData.uploaded_file_id}_security`)}
                  onChange={this.onCheck}
                />
              */}
                <div className="hover_box">
                  <div className="belt_chart">
                    <div className="red">{this.abbreviateNumber(rowData.security_count.critical)}</div>
                    <div className="orange">{this.abbreviateNumber(rowData.security_count.high)}</div>
                    <div className="cheese">{this.abbreviateNumber(rowData.security_count.medium)}</div>
                    <div className="yellow">{this.abbreviateNumber(rowData.security_count.low)}</div>
                  </div>
                  {/*<span className="dot blue" />*/}
                </div>
              </td>
              <td className="License">
                {/**
                <Checkbox
                  value={`${rowData.uploaded_file_id}_license`}
                  checked={renderCheckValue(`${rowData.uploaded_file_id}_license`)}
                  onChange={this.onCheck}
                />
              */}
                <div className="hover_box">
                  <div className="belt_chart round">
                    <div className="red">{this.abbreviateNumber(rowData.license_count.protective)}</div>
                    <div className="cheese">{this.abbreviateNumber(rowData.license_count.permissive)}</div>
                    <div className="yellow">{this.abbreviateNumber(rowData.license_count.others)}</div>
                  </div>
                  {/*<span className="dot blue" />*/}
                </div>
              </td>
              <td className="Litigator">
                {/**
                <Checkbox
                  value={`${rowData.uploaded_file_id}_litigator`}
                  checked={renderCheckValue(`${rowData.uploaded_file_id}_litigator`)}
                  onChange={this.onCheck}
                />
              */}
                <div className="hover_box">
                  <span className="value">
                    {/*<div className="checkbox" /> McHardy (2)<span className="dot blue" />*/}
                    <span>{rowData.litigator_string}</span>
                  </span>
                </div>
              </td>
              <td>{rowData.uploaded_at}</td>
              <td>{this.renderJiraIssueEle(rowData)}</td>
              <td className="expand_button_wrap">
                <a
                  className="expand_button"
                  onClick={(e) => {
                    return this.toggleRow(e, rowData.uploaded_file_id);
                  }}
                  onKeyUp={(e) => {
                    return this.toggleRow(e, rowData.uploaded_file_id);
                  }}
                >
                  <img src={expandBtn} alt="" />
                </a>
              </td>
            </tr>
            {
              isDetailLoading && isVisible === rowData.uploaded_file_id ? (
                <tr>
                  <td colSpan="11" style={{ border: 'none' }}>
                    <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                      <Loader active={isDetailLoading && isVisible === rowData.uploaded_file_id} inline="centered" />
                    </div>
                  </td>
                </tr>
              ) : (
                <tr
                  className="my_issues_item_content"
                  //key={entity.scanned_file_id}
                >
                  <td className="checkbox_wrap">
                    &nbsp;
                  </td>
                  <td className="uploaded_file">
                    &nbsp;
                  </td>
                  <td colSpan="9">
                    {
                      <Scrollbars
                        renderTrackHorizontal={() => {
                          return <div />;
                        }}
                        renderThumbHorizontal={() => {
                          return <div />;
                        }}
                        style={{
                          height: '440px',
                          overflow: 'hidden',
                          position: 'relative',
                        }}
                        onScroll={this.handleDetailScroll}
                      >
                        {
                          rowData.issue_list
                          && rowData.issue_list.length !== 0
                          && rowData.issue_list.map((entity) => {
                            return (
                              <table
                                className="wide_card_table wide_card_scope"
                                key={uuidv4()}
                              >
                                <colgroup>
                                  <col style={{ width: '11%', maxWidth: '100px' }} />
                                  <col style={{ width: '5%', maxWidth: '62px' }} />
                                  <col style={{ width: '4.5%', maxWidth: '62px' }} />
                                  <col style={{ width: '20%' }} />
                                  <col style={{ width: '16%' }} />
                                  <col style={{ width: '8%' }} />
                                  <col style={{ width: '' }} />
                                  <col style={{ width: '' }} />
                                  <col style={{ width: '4%', maxWidth: '40px' }} />
                                </colgroup>
                                <tbody>
                                  <tr>
                                    <td className="scanned_file">
                                      <Checkbox
                                        value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}`}
                                        checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}`)}
                                        //indeterminate={renderIndeterminate(`${rowData.uploaded_file_id}_${entity.scanned_file_id}`)}
                                        onChange={this.onCheckScannedFile}
                                      />
                                      <span className="value_box" style={{ cursor: 'text' }}>{entity.scanned_file}</span>
                                    </td>
                                    <td className="component">
                                      <p className="value_box">{entity.component_count}</p>
                                    </td>
                                    <td className="comp_version">{entity.component_version_count}</td>
                                    <td className="security_risk">
                                      {/**
                                      <Checkbox
                                        value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}_security`}
                                        checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_security`)}
                                        //indeterminate={renderIndeterminate(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_security`)}
                                        onChange={this.onCheckFile}
                                      />
                                      */}
                                      <Popup
                                        trigger={(
                                          <div className="hover_box">
                                            <div className="belt_chart">
                                              <div className="red">{this.abbreviateNumber(entity.security_count.critical)}</div>
                                              <div className="orange">{this.abbreviateNumber(entity.security_count.high)}</div>
                                              <div className="cheese">{this.abbreviateNumber(entity.security_count.medium)}</div>
                                              <div className="yellow">{this.abbreviateNumber(entity.security_count.low)}</div>
                                            </div>
                                            {/*<span className="dot blue" />*/}
                                          </div>
                                        )}
                                        inverted
                                        on="click"
                                        position="bottom left"
                                        open={
                                          popupStatus.file_security && activePopupIndex === `${rowData.uploaded_file_id}_${entity.scanned_file_id}_security` && activeIndex.indexOf(rowData.uploaded_file_id) >= 0
                                        }
                                        onOpen={() => {
                                          return this.getFileIssue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_security`);
                                        }}
                                        onClose={this.closePopup}
                                      >
                                        <div className="my_issues_expand_sub_popup">
                                          <div className="my_issues_expand_sub_popup_header">
                                            <div className="button_wrap">
                                              <a
                                                className="button cancel_button"
                                                onClick={this.closePopup}
                                                onKeyUp={this.closePopup}
                                              >
                                                {translate('modal.button.cancel')}
                                              </a>
                                              <a
                                                className="button save_button"
                                                onClick={() => { return this.saveIssueWithFile(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_security`); }}
                                                onKeyUp={() => { return this.saveIssueWithFile(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_security`); }}
                                              >
                                                {translate('modal.button.save')}
                                              </a>
                                            </div>
                                          </div>
                                          <table className="my_issues_expand_sub_popup_table">
                                            <colgroup>
                                              <col style={{ width: '13%' }} />
                                              <col style={{ width: '25%' }} />
                                              <col style={{ width: '20%' }} />
                                              <col style={{ width: '18%' }} />
                                              <col style={{ width: '15%' }} />
                                              <col style={{ width: '9%' }} />
                                            </colgroup>
                                            <tbody>
                                              <tr>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.risk_level')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    <span className="checkbox" />
                                                    <p className="block bullet">{translate('list.title.risk_code')}</p>
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.component')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.status')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.issue_owner')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.assign')}
                                                  </div>
                                                </th>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div className="my_issues_expand_sub_popup_table_wrap">
                                            <Scrollbars
                                              renderTrackHorizontal={() => {
                                                return <div />;
                                              }}
                                              renderThumbHorizontal={() => {
                                                return <div />;
                                              }}
                                              style={{
                                                height: '318px',
                                                overflow: 'hidden',
                                                position: 'relative',
                                              }}
                                            >
                                              {
                                                isLoadingPopup ? (
                                                  <Segment>
                                                    <Dimmer active>
                                                      <Loader size="small" />
                                                    </Dimmer>
                                                  </Segment>
                                                ) : (
                                                  <table className="my_issues_expand_sub_popup_table">
                                                    <colgroup>
                                                      <col style={{ width: '13%' }} />
                                                      <col style={{ width: '25%' }} />
                                                      <col style={{ width: '20%' }} />
                                                      <col style={{ width: '18%' }} />
                                                      <col style={{ width: '15%' }} />
                                                      <col style={{ width: '9%' }} />
                                                    </colgroup>
                                                    <tbody>
                                                      {
                                                        this.renderRowWithSecurity(fileIssueList, `${rowData.uploaded_file_id}_${entity.scanned_file_id}_security`)
                                                      }
                                                    </tbody>
                                                  </table>
                                                )
                                              }
                                            </Scrollbars>
                                          </div>
                                        </div>
                                      </Popup>
                                    </td>
                                    <td className="License">
                                      {/**
                                      <Checkbox
                                        value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}_license`}
                                        checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_license`)}
                                        //indeterminate={renderIndeterminate(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_license`)}
                                        onChange={this.onCheckFile}
                                      />
                                      */}
                                      <Popup
                                        trigger={(
                                          <div className="hover_box">
                                            {/** <include data-url="components/my_issues_expand_sub_popup.html"></include> */}
                                            <div className="belt_chart round">
                                              <div className="red">{this.abbreviateNumber(entity.license_count.protective)}</div>
                                              <div className="cheese">{this.abbreviateNumber(entity.license_count.permissive)}</div>
                                              <div className="yellow">{this.abbreviateNumber(entity.license_count.others)}</div>
                                            </div>
                                            {/*<span className="dot blue" />*/}
                                          </div>
                                        )}
                                        inverted
                                        on="click"
                                        position="bottom left"
                                        open={
                                          popupStatus.file_license && activePopupIndex === `${rowData.uploaded_file_id}_${entity.scanned_file_id}_license` && activeIndex.indexOf(rowData.uploaded_file_id) >= 0
                                        }
                                        onOpen={() => {
                                          return this.getFileIssue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_license`);
                                        }}
                                        onClose={this.closePopup}
                                      >
                                        <div className="my_issues_expand_sub_popup">
                                          <div className="my_issues_expand_sub_popup_header">
                                            <div className="button_wrap">
                                              <a
                                                className="button cancel_button"
                                                onClick={this.closePopup}
                                                onKeyUp={this.closePopup}
                                              >
                                                {translate('modal.button.cancel')}
                                              </a>
                                              <a
                                                className="button save_button"
                                                onClick={() => { return this.saveIssueWithFile(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_license`); }}
                                                onKeyUp={() => { return this.saveIssueWithFile(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_license`); }}
                                              >
                                                {translate('modal.button.save')}
                                              </a>
                                            </div>
                                          </div>
                                          <table className="my_issues_expand_sub_popup_table">
                                            <colgroup>
                                              <col style={{ width: '18%' }} />
                                              <col style={{ width: '22%' }} />
                                              <col style={{ width: '19%' }} />
                                              <col style={{ width: '18%' }} />
                                              <col style={{ width: '15%' }} />
                                              <col style={{ width: '8%' }} />
                                            </colgroup>
                                            <tbody>
                                              <tr>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.license_family')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    <span className="checkbox" />
                                                    <p className="block bullet">{translate('list.title.license_name')}</p>
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.component')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.status')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.issue_owner')}
                                                  </div>
                                                </th>
                                                <th>
                                                  <div className="scope_title">
                                                    {translate('list.title.assign')}
                                                  </div>
                                                </th>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <div className="my_issues_expand_sub_popup_table_wrap">
                                            <Scrollbars
                                              renderTrackHorizontal={() => {
                                                return <div />;
                                              }}
                                              renderThumbHorizontal={() => {
                                                return <div />;
                                              }}
                                              style={{
                                                height: '318px',
                                                overflow: 'hidden',
                                                position: 'relative',
                                              }}
                                            >
                                              {
                                                isLoadingPopup ? (
                                                  <Segment>
                                                    <Dimmer active>
                                                      <Loader size="small" />
                                                    </Dimmer>
                                                  </Segment>
                                                ) : (
                                                  <table className="my_issues_expand_sub_popup_table">
                                                    <colgroup>
                                                      <col style={{ width: '18%' }} />
                                                      <col style={{ width: '22%' }} />
                                                      <col style={{ width: '19%' }} />
                                                      <col style={{ width: '18%' }} />
                                                      <col style={{ width: '15%' }} />
                                                      <col style={{ width: '8%' }} />
                                                    </colgroup>
                                                    <tbody>
                                                      {
                                                        this.renderRowWithLicense(fileIssueList, `${rowData.uploaded_file_id}_${entity.scanned_file_id}_license`)
                                                      }
                                                    </tbody>
                                                  </table>
                                                )
                                              }
                                            </Scrollbars>
                                          </div>
                                        </div>
                                      </Popup>
                                    </td>
                                    <td className="Litigator">
                                      {/**
                                      <Checkbox
                                        value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator`}
                                        checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator`)}
                                        //indeterminate={renderIndeterminate(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator`)}
                                        onChange={this.onCheckFile}
                                      />
                                      */}
                                      {
                                        entity.litigator_string !== '-' ? (
                                          <Popup
                                            trigger={(
                                              <div className="hover_box">
                                                <span className="value">
                                                  {entity.litigator_string}
                                                </span>
                                              </div>
                                            )}
                                            inverted
                                            on="click"
                                            position="bottom left"
                                            open={
                                              popupStatus.file_litigator && activePopupIndex === `${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator` && activeIndex.indexOf(rowData.uploaded_file_id) >= 0
                                            }
                                            onOpen={() => {
                                              return this.getFileIssue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator`);
                                            }}
                                            onClose={this.closePopup}
                                          >
                                            <div className="my_issues_expand_sub_popup">
                                              <div className="my_issues_expand_sub_popup_header">
                                                <div className="button_wrap">
                                                  <a
                                                    className="button cancel_button"
                                                    onClick={this.closePopup}
                                                    onKeyUp={this.closePopup}
                                                  >
                                                    {translate('modal.button.cancel')}
                                                  </a>
                                                  <a
                                                    className="button save_button"
                                                    onClick={() => { return this.saveIssueWithFile(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator`); }}
                                                    onKeyUp={() => { return this.saveIssueWithFile(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator`); }}
                                                  >
                                                    {translate('modal.button.save')}
                                                  </a>
                                                </div>
                                              </div>
                                              <table className="my_issues_expand_sub_popup_table">
                                                <colgroup>
                                                  <col style={{ width: '18%' }} />
                                                  <col style={{ width: '41%' }} />
                                                  <col style={{ width: '18%' }} />
                                                  <col style={{ width: '15%' }} />
                                                  <col style={{ width: '8%' }} />
                                                </colgroup>
                                                <tbody>
                                                  <tr>
                                                    <th>
                                                      <div className="scope_title">
                                                        {translate('list.title.litigator_code')}
                                                      </div>
                                                    </th>
                                                    <th>
                                                      <div className="scope_title">
                                                        <span className="checkbox" />
                                                        <p className="block bullet">{translate('list.title.component')}</p>
                                                      </div>
                                                    </th>
                                                    <th>
                                                      <div className="scope_title">
                                                        {translate('list.title.status')}
                                                      </div>
                                                    </th>
                                                    <th>
                                                      <div className="scope_title">
                                                        {translate('list.title.issue_owner')}
                                                      </div>
                                                    </th>
                                                    <th>
                                                      <div className="scope_title">
                                                        {translate('list.title.assign')}
                                                      </div>
                                                    </th>
                                                  </tr>
                                                </tbody>
                                              </table>
                                              <div className="my_issues_expand_sub_popup_table_wrap">
                                                <Scrollbars
                                                  renderTrackHorizontal={() => {
                                                    return <div />;
                                                  }}
                                                  renderThumbHorizontal={() => {
                                                    return <div />;
                                                  }}
                                                  style={{
                                                    height: '318px',
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                  }}
                                                >
                                                  {
                                                    isLoadingPopup ? (
                                                      <Segment>
                                                        <Dimmer active>
                                                          <Loader size="small" />
                                                        </Dimmer>
                                                      </Segment>
                                                    ) : (
                                                      <table className="my_issues_expand_sub_popup_table">
                                                        <colgroup>
                                                          <col style={{ width: '18%' }} />
                                                          <col style={{ width: '41%' }} />
                                                          <col style={{ width: '18%' }} />
                                                          <col style={{ width: '15%' }} />
                                                          <col style={{ width: '8%' }} />
                                                        </colgroup>
                                                        <tbody>
                                                          {
                                                            this.renderRowWithLitigator(fileIssueList, `${rowData.uploaded_file_id}_${entity.scanned_file_id}_litigator`)
                                                          }
                                                        </tbody>
                                                      </table>
                                                    )
                                                  }
                                                </Scrollbars>
                                              </div>
                                            </div>
                                          </Popup>
                                        ) : (
                                          <div className="disable_hover">
                                            <span className="value">
                                              {entity.litigator_string}
                                            </span>
                                          </div>
                                        )
                                      }
                                    </td>
                                    <td>&nbsp;</td>
                                    <td className="expand_button_wrap">
                                      &nbsp;
                                    </td>
                                  </tr>
                                  {
                                    entity.components.length !== 0
                                    && entity.components.map((nest, index) => {
                                      return (
                                        <tr key={uuidv4()}>
                                          {
                                            index === entity.components.length - 1 ? (
                                              <td className="component">
                                                &nbsp;
                                              </td>
                                            ) : (
                                              <td className="scanned_file">
                                                &nbsp;
                                              </td>
                                            )
                                          }
                                          <td className="component">
                                            {/**
                                            <Checkbox
                                              value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}`}
                                              onChange={this.onCheckComponentAll}
                                              checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}`)}
                                              //indeterminate={renderIndeterminate(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}`)}
                                            />
                                            */}
                                            <span className="value_box">{nest.component}</span>
                                          </td>
                                          <td className="comp_version">{nest.component_version}</td>
                                          <td className="security_risk">
                                            {/**
                                            <Checkbox
                                              value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_security`}
                                              onChange={this.onCheckComponent}
                                              checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_security`)}
                                            />
                                            */}
                                            <Popup
                                              trigger={(
                                                <div className="hover_box">
                                                  <div className="belt_chart">
                                                    <div className="red">{this.abbreviateNumber(nest.security_count.critical)}</div>
                                                    <div className="orange">{this.abbreviateNumber(nest.security_count.high)}</div>
                                                    <div className="cheese">{this.abbreviateNumber(nest.security_count.medium)}</div>
                                                    <div className="yellow">{this.abbreviateNumber(nest.security_count.low)}</div>
                                                  </div>
                                                </div>
                                              )}
                                              inverted
                                              on="click"
                                              position="bottom left"
                                              open={
                                                popupStatus.component_security && activePopupIndex === `${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_security` && activeIndex.indexOf(rowData.uploaded_file_id) >= 0
                                              }
                                              onOpen={() => {
                                                return this.getComponentIssue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_security`);
                                              }}
                                              onClose={this.closePopup}
                                            >
                                              <div className="my_issues_expand_sub_popup">
                                                <div className="my_issues_expand_sub_popup_header">
                                                  <div className="button_wrap">
                                                    <a
                                                      className="button cancel_button"
                                                      onClick={this.closePopup}
                                                      onKeyUp={this.closePopup}
                                                    >
                                                      {translate('modal.button.cancel')}
                                                    </a>
                                                    <a
                                                      className="button save_button"
                                                      onClick={() => { return this.saveIssueWithComponent(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_security`); }}
                                                      onKeyUp={() => { return this.saveIssueWithComponent(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_security`); }}
                                                    >
                                                      {translate('modal.button.save')}
                                                    </a>
                                                  </div>
                                                </div>
                                                <table className="my_issues_expand_sub_popup_table">
                                                  <colgroup>
                                                    <col style={{ width: '13%' }} />
                                                    <col style={{ width: '25%' }} />
                                                    <col style={{ width: '20%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '15%' }} />
                                                    <col style={{ width: '9%' }} />
                                                  </colgroup>
                                                  <tbody>
                                                    <tr>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.risk_level')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          <span className="checkbox" />
                                                          <p className="block bullet">{translate('list.title.risk_code')}</p>
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.component')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.status')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.issue_owner')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.assign')}
                                                        </div>
                                                      </th>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                                <div className="my_issues_expand_sub_popup_table_wrap">
                                                  <Scrollbars
                                                    renderTrackHorizontal={() => {
                                                      return <div />;
                                                    }}
                                                    renderThumbHorizontal={() => {
                                                      return <div />;
                                                    }}
                                                    style={{
                                                      height: '318px',
                                                      overflow: 'hidden',
                                                      position: 'relative',
                                                    }}
                                                  >
                                                    {
                                                      isLoadingPopup ? (
                                                        <Segment>
                                                          <Dimmer active>
                                                            <Loader size="small" />
                                                          </Dimmer>
                                                        </Segment>
                                                      ) : (
                                                        <table className="my_issues_expand_sub_popup_table">
                                                          <colgroup>
                                                            <col style={{ width: '13%' }} />
                                                            <col style={{ width: '25%' }} />
                                                            <col style={{ width: '20%' }} />
                                                            <col style={{ width: '18%' }} />
                                                            <col style={{ width: '15%' }} />
                                                            <col style={{ width: '9%' }} />
                                                          </colgroup>
                                                          <tbody>
                                                            {
                                                              this.renderRowWithSecurity(fileIssueList, `${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_security`)
                                                            }
                                                          </tbody>
                                                        </table>
                                                      )
                                                    }
                                                  </Scrollbars>
                                                </div>
                                              </div>
                                            </Popup>
                                          </td>
                                          <td className="License">
                                            {/**
                                            <Checkbox
                                              value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_license`}
                                              onChange={this.onCheckComponent}
                                              checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_license`)}
                                            />
                                            */}
                                            <Popup
                                              trigger={(
                                                <div className="hover_box">
                                                  <div className="belt_chart round">
                                                    <div className="red">{this.abbreviateNumber(nest.license_count.protective)}</div>
                                                    <div className="cheese">{this.abbreviateNumber(nest.license_count.permissive)}</div>
                                                    <div className="yellow">{this.abbreviateNumber(nest.license_count.others)}</div>
                                                  </div>
                                                </div>
                                              )}
                                              inverted
                                              on="click"
                                              position="bottom left"
                                              open={
                                                popupStatus.component_license && activePopupIndex === `${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_license` && activeIndex.indexOf(rowData.uploaded_file_id) >= 0
                                              }
                                              onOpen={() => {
                                                return this.getComponentIssue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_license`);
                                              }}
                                              onClose={this.closePopup}
                                            >
                                              <div className="my_issues_expand_sub_popup">
                                                <div className="my_issues_expand_sub_popup_header">
                                                  <div className="button_wrap">
                                                    <a
                                                      className="button cancel_button"
                                                      onClick={this.closePopup}
                                                      onKeyUp={this.closePopup}
                                                    >
                                                      {translate('modal.button.cancel')}

                                                    </a>
                                                    <a
                                                      className="button save_button"
                                                      onClick={() => { return this.saveIssueWithComponent(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_license`); }}
                                                      onKeyUp={() => { return this.saveIssueWithComponent(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_license`); }}
                                                    >
                                                      {translate('modal.button.save')}

                                                    </a>
                                                  </div>
                                                </div>
                                                <table className="my_issues_expand_sub_popup_table">
                                                  <colgroup>
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '22%' }} />
                                                    <col style={{ width: '19%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '15%' }} />
                                                    <col style={{ width: '8%' }} />
                                                  </colgroup>
                                                  <tbody>
                                                    <tr>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.license_family')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          <span className="checkbox" />
                                                          <p className="block bullet">{translate('list.title.license_name')}</p>
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.component')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.status')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.issue_owner')}
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="scope_title">
                                                          {translate('list.title.assign')}
                                                        </div>
                                                      </th>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                                <div className="my_issues_expand_sub_popup_table_wrap">
                                                  <Scrollbars
                                                    renderTrackHorizontal={() => {
                                                      return <div />;
                                                    }}
                                                    renderThumbHorizontal={() => {
                                                      return <div />;
                                                    }}
                                                    style={{
                                                      height: '318px',
                                                      overflow: 'hidden',
                                                      position: 'relative',
                                                    }}
                                                  >
                                                    {
                                                      isLoadingPopup ? (
                                                        <Segment>
                                                          <Dimmer active>
                                                            <Loader size="small" />
                                                          </Dimmer>
                                                        </Segment>
                                                      ) : (
                                                        <table className="my_issues_expand_sub_popup_table">
                                                          <colgroup>
                                                            <col style={{ width: '18%' }} />
                                                            <col style={{ width: '22%' }} />
                                                            <col style={{ width: '19%' }} />
                                                            <col style={{ width: '18%' }} />
                                                            <col style={{ width: '15%' }} />
                                                            <col style={{ width: '8%' }} />
                                                          </colgroup>
                                                          <tbody>
                                                            {
                                                              this.renderRowWithLicense(fileIssueList, `${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_license`)
                                                            }
                                                          </tbody>
                                                        </table>
                                                      )
                                                    }
                                                  </Scrollbars>
                                                </div>
                                              </div>
                                            </Popup>
                                          </td>
                                          <td className="Litigator">
                                            {/**
                                            <Checkbox
                                              value={`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_litigator`}
                                              onChange={this.onCheckComponent}
                                              checked={renderCheckValue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_litigator`)}
                                            />
                                            */}
                                            {
                                              nest.litigator_string !== '-' ? (
                                                <Popup
                                                  trigger={(
                                                    <div className="hover_box">
                                                      <span className="value">
                                                        {nest.litigator_string}
                                                      </span>
                                                    </div>
                                                  )}
                                                  inverted
                                                  on="click"
                                                  position="bottom left"
                                                  open={
                                                    popupStatus.component_litigator && activePopupIndex === `${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_litigator` && activeIndex.indexOf(rowData.uploaded_file_id) >= 0
                                                  }
                                                  onOpen={() => {
                                                    return this.getComponentIssue(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_litigator`);
                                                  }}
                                                  onClose={this.closePopup}
                                                >
                                                  <div className="my_issues_expand_sub_popup">
                                                    <div className="my_issues_expand_sub_popup_header">
                                                      <div className="button_wrap">
                                                        <a
                                                          className="button cancel_button"
                                                          onClick={this.closePopup}
                                                          onKeyUp={this.closePopup}
                                                        >
                                                          {translate('modal.button.cancel')}
                                                        </a>
                                                        <a
                                                          className="button save_button"
                                                          onClick={() => { return this.saveIssueWithComponent(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_litigator`); }}
                                                          onKeyUp={() => { return this.saveIssueWithComponent(`${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_litigator`); }}
                                                        >
                                                          {translate('modal.button.save')}
                                                        </a>
                                                      </div>
                                                    </div>
                                                    <table className="my_issues_expand_sub_popup_table">
                                                      <colgroup>
                                                        <col style={{ width: '18%' }} />
                                                        <col style={{ width: '41%' }} />
                                                        <col style={{ width: '18%' }} />
                                                        <col style={{ width: '15%' }} />
                                                        <col style={{ width: '8%' }} />
                                                      </colgroup>
                                                      <tbody>
                                                        <tr>
                                                          <th>
                                                            <div className="scope_title">
                                                              {translate('list.title.litigator_code')}
                                                            </div>
                                                          </th>
                                                          <th>
                                                            <div className="scope_title">
                                                              <span className="checkbox" />
                                                              <p className="block bullet">{translate('list.title.component')}</p>
                                                            </div>
                                                          </th>
                                                          <th>
                                                            <div className="scope_title">
                                                              {translate('list.title.status')}
                                                            </div>
                                                          </th>
                                                          <th>
                                                            <div className="scope_title">
                                                              {translate('list.title.issue_owner')}
                                                            </div>
                                                          </th>
                                                          <th>
                                                            <div className="scope_title">
                                                              {translate('list.title.assign')}
                                                            </div>
                                                          </th>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <div className="my_issues_expand_sub_popup_table_wrap">
                                                      <Scrollbars
                                                        renderTrackHorizontal={() => {
                                                          return <div />;
                                                        }}
                                                        renderThumbHorizontal={() => {
                                                          return <div />;
                                                        }}
                                                        style={{
                                                          height: '318px',
                                                          overflow: 'hidden',
                                                          position: 'relative',
                                                        }}
                                                      >
                                                        {
                                                          isLoadingPopup ? (
                                                            <Segment>
                                                              <Dimmer active>
                                                                <Loader size="small" />
                                                              </Dimmer>
                                                            </Segment>
                                                          ) : (
                                                            <table className="my_issues_expand_sub_popup_table">
                                                              <colgroup>
                                                                <col style={{ width: '18%' }} />
                                                                <col style={{ width: '41%' }} />
                                                                <col style={{ width: '18%' }} />
                                                                <col style={{ width: '15%' }} />
                                                                <col style={{ width: '8%' }} />
                                                              </colgroup>
                                                              <tbody>
                                                                {
                                                                  this.renderRowWithLitigator(fileIssueList, `${rowData.uploaded_file_id}_${entity.scanned_file_id}_${nest.file_component_id}_litigator`)
                                                                }
                                                              </tbody>
                                                            </table>
                                                          )
                                                        }
                                                      </Scrollbars>
                                                    </div>
                                                  </div>
                                                </Popup>
                                              ) : (
                                                <div className="disable_hover">
                                                  <span className="value">
                                                    {nest.litigator_string}
                                                  </span>
                                                </div>
                                              )
                                            }
                                          </td>
                                        </tr>
                                      );
                                    })
                                  }
                                </tbody>
                              </table>
                            );
                          })
                        }
                        {errorDetail && <div style={{ color: '#900' }}>{translate('modal.error.page_loading_error')}</div>}
                        {isDetailPageLoading && isScrolling === rowData.uploaded_file_id && (
                          <Segment>
                            <Dimmer active inverted>
                              <Loader size="small" />
                            </Dimmer>
                          </Segment>
                        )}
                      </Scrollbars>
                    }
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
        {
          rowData.issue_status
          && (
            <div className="my_issues_item_detail">
              <div className="my_issues_item_detail_top">
                {/**
              <p className="label">
                UPLOAD LOCATION
              </p>
              <p className="text">
                <span>{rowData.project_name}</span><span>/</span><span>{rowData.project_version_name}</span>
              </p>
               */}
                <p className="label">
                  {translate('list.title.upload_user')}
                </p>
                <p className="text">
                  {rowData.uploaded_file_owner}
                </p>
                <p className="label">
                  {translate('list.title.issue_owner')}
                </p>
                <p className="text">
                  {
                    rowData.issue_owner === 'Not Assigned' ? (
                      <span className="popup" style={{ pointerEvents: 'none' }}>{rowData.issue_owner}</span>
                    ) : (
                      <Popup
                        trigger={<span className="popup">{rowData.issue_owner}</span>}
                        on="click"
                        hideOnScroll
                        position="bottom left"
                        open={popupStatus.owner && activePopupIndex === rowData.uploaded_file_id}
                        onOpen={() => { return this.getIssueOwner(rowData.uploaded_file_id); }}
                        onClose={this.closePopup}
                      >
                        <List>
                          <List.Item>
                            {
                              ownerList.map((item) => {
                                return <List.List key={uuidv4()} style={{ fontSize: '12px' }}>{item}</List.List>;
                              })
                            }
                          </List.Item>
                        </List>
                      </Popup>
                    )
                  }
                </p>
              </div>
              <div className="my_issues_item_detail_bottom">
                <p className="label">
                  {translate('list.title.issue_status')}
                </p>
                {this.renderBarChart(rowData.issue_status)}
              </div>
            </div>
          )
        }
        <CreateUserIssueModal
          isOpenMCI={isOpenMCI}
          idReport={uid}
          closeModal={this.closeModal}
          completeCallback={this.handleIssueCallback}
          translate={translate}
          location={location}
        />
      </div>
    );
  }
}

export default WithRouter(inject('state')(observer(OverviewIssueItem)));
